import { StorageKey } from "config/storage";

export type MfeOverride = {
    name: string;
    url: string;
};

export class MfeOverrides {
    static hasAllExactOverrides(overrides: MfeOverride[]) {
        const currentOverrides = MfeOverrides.getOverrides();
        let hasAllRcOverrides = true;
        overrides.forEach((override) => {
            const hasOverride = currentOverrides.some(
                (item) => item.name === override.name && item.url === override.url,
            );
            hasAllRcOverrides = hasAllRcOverrides && hasOverride;
        });
        return hasAllRcOverrides;
    }

    static hasSomeOverridesMatchingName(overrides: MfeOverride[]) {
        const currentOverrides = MfeOverrides.getOverrides();
        let hasSomeRcOverrides = false;
        overrides.forEach((override) => {
            const hasOverride = currentOverrides.some((item) => item.name === override.name);
            hasSomeRcOverrides = hasSomeRcOverrides || hasOverride;
        });
        return hasSomeRcOverrides;
    }

    static addOverrides(overrides: MfeOverride[]): MfeOverride[] {
        const currentOverrides = MfeOverrides.getOverrides();
        overrides.forEach((override) => {
            const currentMatchingOverride = currentOverrides.find((item) => item.name === override.name);
            if (currentMatchingOverride) {
                currentMatchingOverride.url = override.url;
            } else {
                currentOverrides.push(override);
            }
        });

        localStorage.setItem(StorageKey.ProcoreMFEOverrides, JSON.stringify(currentOverrides));
        return currentOverrides;
    }

    static removeOverrides(overrides: MfeOverride[]): MfeOverride[] {
        const currentOverrides = MfeOverrides.getOverrides();
        overrides.forEach((override) => {
            const index = currentOverrides.findIndex((item) => item.name === override.name);
            if (index !== -1) {
                currentOverrides.splice(index, 1);
            }
        });

        localStorage.setItem(StorageKey.ProcoreMFEOverrides, JSON.stringify(currentOverrides));
        return currentOverrides;
    }

    static getOverrides(): MfeOverride[] {
        const lsValue = localStorage.getItem(StorageKey.ProcoreMFEOverrides);
        const currentOverrides: MfeOverride[] = lsValue ? JSON.parse(lsValue) : [];
        if (!Array.isArray(currentOverrides)) {
            throw new Error("MFE Overrides in localStorage is not an array");
        }
        return currentOverrides;
    }

    static clearOverrides() {
        localStorage.removeItem(StorageKey.ProcoreMFEOverrides);
    }
}
